module.exports = __webpack_public_path__ + "0c5b72b712807fddf029315bd426b3c1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-6.svg
// module id = 587
// module chunks = 0